var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF4B4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.85547,
    y: 3.42822,
    width: 2.28572,
    height: 5.71429,
    rx: 1.14286,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19188 8.92388C6.74557 8.47757 6.74556 7.75395 7.19188 7.30763C7.63819 6.86132 8.36181 6.86132 8.80812 7.30763L11.2325 9.732C11.6788 10.1783 11.6788 10.9019 11.2325 11.3482C10.7862 11.7946 10.0626 11.7946 9.61624 11.3482L7.19188 8.92388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default __webpack_public_path__ + "static/media/late.6a85173e7cbfac0b66361baf051a317e.svg";
export { ForwardRef as ReactComponent };